var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:_vm.$root.listItemClasses + ' puzzle-list-item',attrs:{"to":{
    name: 'puzzle',
    params: {
      puzzleId: _vm.puzzle.id
    }
  }}},[_vm._v("\n  "+_vm._s(_vm.puzzle.name)+"\n  "),_c('span',{staticClass:"badge badge-primary"},[_vm._v("\n    "+_vm._s(_vm.$root.displayDateLocalFmt( _vm.puzzle.date ))+"\n  ")]),_vm._v(" "),(!_vm.puzzle.public)?_c('span',[_vm._v("\n    🕶\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2594c15c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PuzzleListItem.vue
// module id = 1150
// module chunks = 1